export const data = {
  title: {
    pt: "A minha Experiência",
    eng: "My Experience",
  },
  explorebtn: {
    pt: "",
    eng: "Check it out",
  },
  work: [
    {
      title: {
        pt: "Engenheiro de Segurança de Aplicações",
        eng: "Application Security Engineer",
      },
      duration: {
        pt: "Set 2024 - Atual.",
        eng: "Sep 2024 - Current",
      },
      company: {
        pt: "Checkmarx - Braga",
        eng: "Checkmarx - Braga",
      },
      desc: [
        {
          pt: "",
          eng: "As an Application Security Engineer at Checkmarx, I focus improving our engines through static analysis and vulnerability research. I perform deep static analysis on large-scale systems and open source projects to detect security flaws and match them to our engines' results.",
        },
        {
          pt: "",
          eng: "Building on my software engineering background, I am also responsible for the design and development of internal tools and automation platforms that support the Application Security team. My work bridges security analysis with software engineering, enabling more efficient, data-driven decision-making.",
        },
        {
          pt: "",
          eng: "My main project in this role is the CLab Platform — a comprehensive system that parses and visualizes results from multiple SAST, DAST, and IaC engines such as Checkmarx, Snyk, Veracode, GitHub Advanced Security, and Semgrep. The platform highlights results in their respective source files, allowing analysts to classify findings as True Positive (TP), False Positive (FP), or Not Exploitable (NE). This unified analysis environment provides an unbiased view of various security engines, enabling fair comparisons and deeper understanding of strengths and weaknesses across the market.",
        },
        {
          pt: "",
          eng: "Beyond tool development, I actively engage in vulnerability research — discovering, reproducing, and studying new security flaws. These findings are later translated into detection queries or research reports that enhance our products’ capabilities and threat coverage.",
        },
        {
          pt: "",
          eng: "I also participate in CVE Hunt initiatives, where our team targets specific technologies or products to uncover new vulnerabilities over dedicated research sprints. These exercises often lead to valuable CVE discoveries and strengthen our offensive security expertise.",
        },
        {
          pt: "",
          eng: "Through my technical analysis and collaboration with product teams, I have directly contributed to the successful retention of key clients who were considering alternative SAST/DAST/IaC solutions — reinforcing the value and competitiveness of our security products.",
        },
        {
          pt: "",
          eng: "Overall, my role combines hands-on security research, software engineering, and analytical thinking to build tools, identify vulnerabilities, and empower the organization to deliver stronger and more reliable security solutions.",
        },
      ],
      companyurl: "https://checkmarx.com/",
    },
    {
      title: {
        pt: "Engenheiro de Software",
        eng: "Software Engineer",
      },
      duration: {
        pt: "Out 2021 - Set 2024",
        eng: "Oct 2021 - Sep 2024",
      },
      company: {
        pt: "Checkmarx - Braga",
        eng: "Checkmarx - Braga",
      },
      desc: [
        {
          pt: "",
          eng: "As a Software Engineer at Checkmarx, I worked within the Quality Assurance division, primarily focused on software development for internal systems, CI/CD infrastructure, and automation platforms. Although part of the QA organization, my role was centered around backend and full-stack development, maintaining and evolving internal systems critical to the stability and performance of our SAST engine ecosystem.",
        },
        {
          pt: "",
          eng: "Throughout this period, I maintained and improved multiple internal applications and services built using Python (Flask), Node.js (Express.js), Java (Spring Boot), and C# (WPF and ASP.NET), along with React-based frontends. These services supported validation, orchestration, and analysis processes for the company’s security engine.",
        },
        {
          pt: "",
          eng: "I worked extensively with microservices orchestrated through Docker Swarm, refactored legacy codebases to modern standards, and led the effort to containerize multiple applications using Dev Containers. I was also responsible for maintaining and extending Jenkins pipelines while pioneering the adoption of GitHub Actions for new projects, later leading the migration of legacy pipelines to the new CI/CD framework.",
        },
        {
          pt: "",
          eng: "One of my key projects was 'Doppelganger' — an internal management and analytics platform for Checkmarx’s SAST engine test projects. It served as a centralized source of truth for engine results and provided intelligent similarity scoring between projects to measure coverage and reduce redundancy. By identifying overlapping results, the system optimized CI workloads and reduced execution time across thousands of projects.",
        },
        {
          pt: "",
          eng: "Another major initiative I led was the 'Vorpal Regression Management System', a version control and analytics platform that monitored changes in the Vorpal engine’s codebase and automatically tracked regressions or result deviations across test collections. This system allowed developers to detect breaking changes before merging code, integrating features such as multi-branch support, transaction-safe database operations, caching layers, and real-time analytics dashboards for visibility across the team.",
        },
        {
          pt: "",
          eng: "Overall, my work spanned across full-stack development, DevOps, automation, and infrastructure — contributing to the team’s ability to deliver faster, more reliable, and more maintainable internal systems while driving modernization initiatives across the QA organization.",
        },
      ],
      companyurl: "https://checkmarx.com/",
    },
    {
      title: {
        pt: "Estágio de Verão em Desenvolvimento de Software e QA",
        eng: "Summer Internship in Software Development and QA",
      },
      duration: {
        pt: "Ago 2021 - Out 2021",
        eng: "Aug 2021 - Oct 2021",
      },
      company: {
        pt: "Checkmarx - Braga",
        eng: "Checkmarx - Braga",
      },
      desc: [
        {
          pt: "",
          eng: "During my summer internship at Checkmarx, I joined the QA development team where I worked on internal tools supporting the continuous integration and testing pipelines of our products.",
        },
        {
          pt: "",
          eng: "My responsibilities included implementing and maintaining C# and JavaScript-based tools, improving automation workflows, and assisting with CI/CD tasks related to test infrastructure. I gained early hands-on experience with software development practices, version control, and internal process optimization.",
        },
        {
          pt: "",
          eng: "Additionally, I developed a small desktop automation app using Electron and React to streamline repetitive QA operations, automatically generating reports and handling issue tracking. This project sparked my passion for combining development with automation to improve workflows.",
        },
      ],
      companyurl: "https://checkmarx.com/",
    },
  ],
};
